import React, { useEffect, useRef } from 'react'
import './index.css'
import AnimatedCounter from '../Shared/AnimatedCounter';
import cdmoSection1Bg from "../assests/CDMOImages/cdmo-section1-bg.png";

import section2img from "../assests/HomeImg/section2-img.svg";
import moleculesIcon from "../assests/CDMOImages/Molecules Developed-icon.svg";
import manufacturingIcon from "../assests/CDMOImages/Manufacturing Sites-icon.svg";
import countriesIcon from "../assests/CDMOImages/Countries Supplied-icon.svg";
import usfdaIcon from "../assests/CDMOImages/USFDA Approved Units-icon.svg";

import cdmoSection2LeftImage from "../assests/CDMOImages/cdmo-section2-Left Image.png";
import cdmoSection2RightIcon from "../assests/CDMOImages/cdmo-section2-right-icon.svg";

import cdmoContractDevelopmentIcon1 from "../assests/CDMOImages/cdmo-contract-development-icon1.svg";
import cdmoContractDevelopmentIcon2 from "../assests/CDMOImages/cdmo-contract-development-icon2.svg";
import cdmoContractDevelopmentIcon3 from "../assests/CDMOImages/cdmo-contract-development-icon3.svg";
import cdmoContractDevelopmentIcon4 from "../assests/CDMOImages/cdmo-contract-development-icon4.svg";

import cdmoContractManufacturingIcon1 from "../assests/CDMOImages/cdmo-contract-manufacturing-icon1.svg";
import cdmoContractManufacturingIcon2 from "../assests/CDMOImages/cdmo-contract-manufacturing-icon2.svg";
import cdmoContractManufacturingIcon3 from "../assests/CDMOImages/cdmo-contract-manufacturing-icon3.svg";
import cdmoContractManufacturingIcon4 from "../assests/CDMOImages/cdmo-contract-manufacturing-icon4.svg";


import cdmoContractManufacturingLeftImg from "../assests/CDMOImages/cdmo-ContractManufacturing-left-img.png";

import apiCommercialIcon from "../assests/CDMOImages/API Commercial Manufacturing-icon.svg";
import fdfIcon from "../assests/CDMOImages/FDF Manufacturing-icon.svg";
import animalHealthIcon from "../assests/CDMOImages/Animal Health Manufacturing-icon.svg";
import qualitySupplyIcon from "../assests/CDMOImages/Quality & Supply Chain-icon.svg";
import manufacturingApprovalsIcon from "../assests/CDMOImages/Manufacturing Approvals & Certifications-icon.svg";

import TechnologyPlatformsBanner from "../assests/CDMOImages/TechnologyPlatforms-banner.png";

import flowChemistryIcon from "../assests/CDMOImages/Continuous Flow Chemistry-icon.svg";
import chiralChemistryIcon from "../assests/CDMOImages/Chiral Chemistry-icon.svg";
import ironComplexIcon from "../assests/CDMOImages/Iron Complex Technology-icon.svg";
import nitrosamineIcon from "../assests/CDMOImages/Nitrosamine Risk Management-icon.svg";
import hplcIcon from "../assests/CDMOImages/Preparative HPLC Purification-icon.svg";
import cytotoxicIcon from "../assests/CDMOImages/Cytotoxic & Potent Compounds-icon.svg";
import polymorphIcon from "../assests/CDMOImages/Polymorph Engineering-icon.svg";
import processSafetyIcon from "../assests/CDMOImages/Process Safety Technology-icon.svg";

import discoveryIcon from "../assests/CDMOImages/cdmo-Discovery-icon.svg";
import preClinicalIcon from "../assests/CDMOImages/cdmo-Pre-clinical-icon.svg";
import phase1Icon from "../assests/CDMOImages/cdmo-Phase1-icon.svg"
import phase3Icon from "../assests/CDMOImages/cdmo-PhaseIII-icon.svg";
import approvalIcon from "../assests/CDMOImages/cdmo-Approval-icon.svg";
import commercialIcon from "../assests/CDMOImages/cdmo-Commercial-icon.svg";

import discoveryArrow from "../assests/CDMOImages/cdmo-Discovery-arrow.svg";
import preClinicalArrow from "../assests/CDMOImages/cdmo-Pre-clinical-arrow.svg";
import phase1Arrow from "../assests/CDMOImages/cdmo-Phase1-arrow.svg";
import phase3Arrow from "../assests/CDMOImages/cdmo-PhaseIII-arrow.svg";
import approvalArrow from "../assests/CDMOImages/cdmo-Approval-arrow.svg";
import commercialArrow from "../assests/CDMOImages/cdmo-Commercial-arrow.svg";

import discoveryCardIcon from "../assests/CDMOImages/cdmo-Discovery-card-icon.svg";
import preClinicalCardIcon from "../assests/CDMOImages/cdmo-Pre-clinical-card-icon.svg";
import phase1CardIcon from "../assests/CDMOImages/cdmo-Phase1-card-icon.svg";
import phase3CardIcon from "../assests/CDMOImages/cdmo-PhaseIII-card-icon.svg";
import approvalCardIcon from "../assests/CDMOImages/cdmo-Approval-card-icon.svg";
import commercialCardIcon from "../assests/CDMOImages/cdmo-Commercial-card-icon.svg";

import cdmoLeftArrowIcon from "../assests/CDMOImages/cdmoLeftArrowIcon.svg";

import cdmoS7CtaIcon from "../assests/CDMOImages/cdmoS7CtaIcon.svg";


const CDMO = () => {

    const cards = [
        // {
        //     icon: flowChemistryIcon,
        //     title: "Continuous Flow Chemistry",
        //     desc: "Safe, reproducible processing of hazardous chemistries at scale with improved yield and selectivity.",
        //     tags: ["Exothermic reactions", "Cryogenic chemistry", "Ozonolysis"]
        // },
        {
            icon: chiralChemistryIcon,
            title: "Chiral Chemistry",
            desc: "Asymmetric synthesis, chiral resolution and enzymatic routes for stereoselective API production.",
            tags: ["Asymmetric catalysis", "Chiral HPLC", "Enzymatic resolution"]
        },
        {
            icon: ironComplexIcon,
            title: "Iron Complex Technology",
            desc: "Proprietary expertise in iron coordination compounds including Iron Sucrose, FCM and Iron Polymaltose.",
            tags: ["Iron Sucrose", "FCM", "Iron Polymaltose"]
        },
        {
            icon: cytotoxicIcon,
            title: "Cytotoxic & Potent Compounds",
            desc: "Contained handling and manufacturing of OEB 4/5 molecules with dedicated isolators and HEPA-filtered suites.",
            tags: ["OEB 4/5", "Oncology molecules", "ISPE SMEPAC"]
        },
        {
            icon: polymorphIcon,
            title: "Polymorph Engineering",
            desc: "Solid-state screening and crystal form control using pXRD, DSC, FT-Raman and FT-IR.",
            tags: ["pXRD", "DSC", "Salt screening"]
        },


        {
            icon: nitrosamineIcon,
            title: "Nitrosamine Risk Management",
            desc: "Dedicated lab for nitrosamine screening, impurity characterisation and risk assessment aligned with ICH M7.",
            tags: ["ICH M7", "NDSRI analysis", "Genotoxic impurities"]
        },
        {
            icon: hplcIcon,
            title: "Preparative HPLC Purification",
            desc: "Large-scale preparative chromatographic separation for highly potent and complex molecules.",
            tags: ["kg-scale", "Reverse phase", "SFC"]
        },


        {
            icon: processSafetyIcon,
            title: "Process Safety Technology",
            desc: "Dedicated process safety lab with ARC, MIT, MIE equipment for full thermal hazard evaluation.",
            tags: ["ARC calorimetry", "LOPA", "Reactive screening"]
        }
    ];


    const lifecycleTimeline = [
        {
            icon: discoveryIcon,
            label: "Discovery",
            sub: "Pre-IND",
            subColor: "#2563EB",
            arrow: discoveryArrow,
        },
        {
            icon: preClinicalIcon,
            label: "Pre-clinical",
            sub: "IND-Enabling",
            subColor: "#7C3AED",
            arrow: preClinicalArrow,
        },
        {
            icon: phase1Icon,
            label: "Phase I/II",
            sub: "Clinical",
            subColor: "#0891B2",
            arrow: phase1Arrow,
        },
        {
            icon: phase3Icon,
            label: "Phase III",
            sub: "Pivotal",
            subColor: "#059669",
            arrow: phase3Arrow,
        },
        {
            icon: approvalIcon,
            label: "Approval",
            sub: "NDA / MAA",
            subColor: "#D97706",
            arrow: approvalArrow,
        },
        {
            icon: commercialIcon,
            label: "Commercial",
            sub: "Launch & Supply",
            subColor: "#059669",
            arrow: commercialArrow,
        },
    ];

    const lifecycleSupportCards = [
        {
            icon: discoveryCardIcon,
            label: "Discovery",
            sub: "Pre-IND",
            subColor: "#2563EB",
            tags: ["Route scouting", "Custom synthesis", "+2 more"],
        },
        {
            icon: preClinicalCardIcon,
            label: "Pre-clinical",
            sub: "IND-Enabling",
            subColor: "#7C3AED",
            tags: ["Process development", "g-scale API supply", "+2 more"],
        },
        {
            icon: phase1CardIcon,
            label: "Phase I/II",
            sub: "Clinical",
            subColor: "#0891B2",
            tags: ["kg-scale batches", "Formulation dev", "+2 more"],
        },
        {
            icon: phase3CardIcon,
            label: "Phase III",
            sub: "Pivotal",
            subColor: "#059669",
            tags: ["Scale-up & validation", "PPQ batches", "+2 more"],
        },
        {
            icon: approvalCardIcon,
            label: "Approval",
            sub: "NDA / MAA",
            subColor: "#D97706",
            tags: ["ANDA / NDA filing", "PAI readiness", "+2 more"],
        },
        {
            icon: commercialCardIcon,
            label: "Commercial",
            sub: "Launch & Supply",
            subColor: "#059669",
            tags: ["Long-term supply agreements", "Multi-site redundancy", "+2 more"],
        },
    ];

    const partneringModels = [
        {
            icon: cdmoContractDevelopmentIcon1,
            title: "Full CDMO Partnership",
            ideal: "Ideal for: Virtual pharma, biotech, innovators",
            desc: "End-to-end engagement covering development, scale-up, regulatory filing and long-term commercial supply - a single-partner solution.",
            bullets: [
                "Dedicated project management team",
                "Seamless dev-to-commercial transition",
                "Single point of contact, integrated timeline",
                "Flexible capacity reservation arrangements",
                "Joint steering committee governance"
            ]
        },
        {
            icon: cdmoContractDevelopmentIcon2,
            title: "API Supply Partnership",
            ideal: "Ideal for: Big Pharma companies",
            desc: "Reliable, long-term API supply for generic pharmaceutical companies - backed by our 11 USFDA-approved API manufacturing sites.",
            bullets: [
                "48 USDMFs available for immediate engagement",
                "40 CEPs for European market access",
                "Dual-site supply continuity options",
                "Backward integration guarantee",
                "Competitive pricing through in-house intermediates"
            ]
        },
        {
            icon: cdmoContractDevelopmentIcon3,
            title: "Co-Development Programme",
            ideal: "Ideal for: Early-stage Products",
            desc: "Collaborative R&D partnerships where Viyash co-invests in development costs in exchange for preferential commercial supply terms.",
            bullets: [
                "Shared development investment model",
                "Risk-share milestones and royalty structures",
                "IP co-ownership or licensing options",
                "Early-stage compound evaluation support",
                "Joint regulatory strategy planning"
            ]
        },
        {
            icon: cdmoContractDevelopmentIcon4,
            title: "Technology Licensing",
            ideal: "Ideal for: Established generic, specialty pharma",
            desc: "Licence Viyash's proprietary processes, analytical methods, or crystal form patents to accelerate your own development programmes.",
            bullets: [
                "55+ granted patents available for licensing",
                "Process know-how transfer packages",
                "Analytical method licensing & training",
                "Crystal form / polymorph IP packages",
                "Ongoing technical support included"
            ]
        }
    ];

    // ========================
    //  SCROLL REVEAL ANIMATIONS
    // ========================
    useEffect(() => {
        // Pre-mark all stagger children as hidden
        document.querySelectorAll("[data-stagger]").forEach((grid) => {
            Array.from(grid.children).forEach((child) => {
                child.classList.add("anim-child");
            });
        });

        // Observer for stagger grids - each child animates individually
        const staggerObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        Array.from(entry.target.children).forEach((child, i) => {
                            child.style.animationDelay = `${i * 0.13}s`;
                            child.classList.add(
                                i % 2 === 0 ? "anim-from-left" : "anim-from-right"
                            );
                        });
                        staggerObserver.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 }
        );

        document
            .querySelectorAll("[data-stagger]")
            .forEach((el) => staggerObserver.observe(el));

        // Observer for section-level reveals
        const sectionObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                        sectionObserver.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.06 }
        );

        document
            .querySelectorAll(".scroll-reveal, .sr-left, .sr-right")
            .forEach((el) => sectionObserver.observe(el));

        return () => {
            staggerObserver.disconnect();
            sectionObserver.disconnect();
        };
    }, []);

    return (
        <>
            {/* ================= CDMO & CAPABILITIES SECTION 1 ================= */}
            <section className="cdmo-section1">

                {/* Background Image */}
                <img
                    src={cdmoSection1Bg}
                    alt="CDMO Background"
                    className="cdmo-section1-bg"
                />

                {/* Gradient Overlay */}
                <div className="cdmo-section1-overlay"></div>

                {/* Content */}
                <div className="cdmo-section1-content sr-left">

                    <h1 className="cdmo-section1-title">
                        CDMO &amp; CAPABILITIES
                    </h1>

                    <p className="cdmo-section1-text">
                        End-to-end pharmaceutical development and manufacturing - from early stage molecule to commercial scale.
                    </p>

                    <p className="cdmo-section1-text2">
                        Viyash Scientific offers an integrated CDMO platform combining deep science, regulatory expertise, and
                        multi-site manufacturing capability. We partner with innovators, generics companies, and virtual pharma
                        across API development, formulation, and commercial supply.
                    </p>

                </div>

            </section>

            {/* ================= Breadcrumb ================= */}
            <div class="cdmo-breadcrumb-container">
                <div class="cdmo-breadcrumb-wrapper">

                    <a href="/" class="cdmo-breadcrumb-link cdmo-home-link">
                        <svg class="cdmo-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14"
                                stroke="#4A5565" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z"
                                stroke="#4A5565" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Home
                    </a>

                    <span class="cdmo-breadcrumb-separator">›</span>

                    <span class="cdmo-breadcrumb-current">CDMO &amp; Capabilities</span>

                </div>
            </div>

            {/* ================= SECTION 2 Your Integrated CDMO Partner================= */}
            <section className="cdmo-section2">

                {/* Header */}
                <div className="cdmo-section2-header scroll-reveal">

                    <h2>Your Integrated CDMO Partner</h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p>
                        Science-led, quality-first, globally compliant pharmaceutical development
                        <br />
                        and manufacturing
                    </p>

                </div>


                {/* Stats Cards */}

                <div className="cdmo-section2-stats" data-stagger="true">

                    {[
                        { icon: moleculesIcon, value: "50+", label: "Molecules Developed" },
                        { icon: manufacturingIcon, value: "15", label: "Manufacturing Sites" },
                        { icon: countriesIcon, value: "100+", label: "Countries Supplied" },
                        { icon: usfdaIcon, value: "11", label: "USFDA Approved Units" }
                    ].map((item) => (

                        <div key={item.label} className="cdmo-section2-stat-card">

                            <div className="cdmo-section2-icon">
                                <img src={item.icon} alt={item.label} />
                            </div>

                            <div className="cdmo-section2-value">
                                <AnimatedCounter value={item.value} />
                            </div>
                            <div className="cdmo-section2-label">{item.label}</div>

                        </div>

                    ))}

                </div>


                {/* Bottom Section */}

                <div className="cdmo-section2-bottom">

                    {/* Left Image */}

                    <div className="cdmo-section2-image sr-left">

                        <img
                            src={cdmoSection2LeftImage}
                            alt="Science Driven Development"
                        />

                        <div className="cdmo-section2-image-overlay">
                            <div className="cdmo-section2-image-title">
                                Science-Driven Development
                            </div>
                            <div className="cdmo-section2-image-desc">
                                First-shot OK chemistry powered by 200+ scientists and 13 dedicated research labs
                            </div>
                        </div>

                    </div>


                    {/* Right Content */}

                    <div className="cdmo-section2-content sr-right">

                        <h3>Why Viyash as Your CDMO?</h3>

                        <p>
                            With a deeply integrated development-to-commercial platform, Viyash eliminates the hand-off risk inherent to fragmented CDMO partnerships.
                            One partner - from IND-enabling to commercial supply.
                        </p>

                        {[
                            "Fully backward-integrated API to finished dose platform",
                            "Dedicated CDMO teams with 200+ R&D scientists including 20+ PhDs",
                            "Track record with regulated markets: US, EU, Japan, Korea, Brazil",
                            "Multi-site redundancy with 10 USFDA-approved manufacturing units",
                            "In-house regulatory filing capability across all major markets",
                            "Flexible capacity: 1 kg lab scale to 1,000 kg commercial batches"
                        ].map((point, i) => (

                            <div key={i} className="cdmo-section2-point">

                                <img src={cdmoSection2RightIcon} alt="Right Check Icon" />

                                <span>{point}</span>

                            </div>

                        ))}

                    </div>

                </div>

            </section>

            {/* ================= SECTION 3 Contract Development Services================= */}

            <section className="cdmo-section3">

                {/* Header */}
                <div className="cdmo-section3-header scroll-reveal">

                    <h2>Contract Development Services</h2>

                    {/* <div className="cdmo-section3-divider">
                        <div className="line left"></div>

                        <svg width="32" height="18" viewBox="0 0 40 22" fill="none">
                            <circle cx="14" cy="11" r="10" fill="#0EA5E9" />
                            <circle cx="26" cy="11" r="10" fill="#F97316" />
                            <circle cx="14" cy="11" r="5" fill="#fff" />
                            <circle cx="26" cy="11" r="5" fill="#fff" />
                        </svg>

                        <div className="line right"></div>
                    </div> */}
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p>
                        From early stage molecule to IND-ready package - fully integrated development services under one roof
                    </p>

                </div>


                {/* Cards */}

                <div className="cdmo-section3-grid" data-stagger="true">

                    {[
                        {
                            headerBg: "#01589B",
                            icon: cdmoContractDevelopmentIcon1,
                            title: "API Process Development",
                            desc: "Route scouting, process optimisation, scale-up and technology transfer for new chemical entities and generic APIs.",
                            points: [
                                "Greenfield synthesis route design",
                                "Multi-step complex molecule expertise",
                                "Chiral chemistry & asymmetric synthesis",
                                "Hazardous chemistry (nitration, hydrogenation)",
                                "Iron complex & coordination chemistry",
                                "Continuous flow process development"
                            ]
                        },
                        {
                            headerBg: "#F8931D",
                            icon: cdmoContractDevelopmentIcon2,
                            title: "Formulation Development",
                            desc: "Solid, semi-solid, liquid and parenteral dose form development with in-house analytical and stability support.",
                            points: [
                                "Oral solid dosage (IR, CR, ER, ODT)",
                                "Sterile injectables & lyophilisation",
                                "Semi-solid and topical formulations",
                                "Bioavailability enhancement (nano, amorphous)",
                                "Paediatric formulations",
                                "Combination products"
                            ]
                        },
                        {
                            headerBg: "#40B749",
                            icon: cdmoContractDevelopmentIcon3,
                            title: "Analytical Development",
                            desc: "Full analytical method development, validation, and transfer from in-house analytical labs equipped with 24 HPLCs, LCMSs, and more.",
                            points: [
                                "Impurity profiling & characterisation",
                                "Nitrosamine & genotoxic impurity testing",
                                "Polymorph & solid-state characterisation",
                                "Reference standard qualification",
                                "Forced degradation & stress testing",
                                "Stability protocols (ICH zones I–IV)"
                            ]
                        },
                        {
                            headerBg: "#00AFEF",
                            icon: cdmoContractDevelopmentIcon4,
                            title: "Regulatory Support",
                            desc: "Comprehensive dossier preparation - DMFs, CEPs, ANDAs, NDAs - backed by in-house regulatory teams.",
                            points: [
                                "48 US DMFs · 33 ANDAs Approved",
                                "40 CEPs · 42 EDMFs filed",
                                "PMDA, KFDA, CADIFA filings",
                                "Pre-submission agency meetings",
                                "CMC strategy and dossier authoring",
                                "Post-approval change management"
                            ]
                        }
                    ].map((card) => (

                        <div key={card.title} className="cdmo-section3-card">

                            <div
                                className="cdmo-section3-card-header"
                                style={{ background: card.headerBg }}
                            >
                                <img src={card.icon} alt={card.title} />
                                <span>{card.title}</span>
                            </div>

                            <div className="cdmo-section3-card-body">

                                <p>{card.desc}</p>

                                <ul>
                                    {card.points.map((pt) => (
                                        <li key={pt}>{pt}</li>
                                    ))}
                                </ul>

                            </div>

                        </div>

                    ))}

                </div>

            </section>

            {/* ================= SECTION 4 Contract Manufacturing================= */}

            <section className="cdmo-section4">

                {/* Header */}
                <div className="cdmo-section4-header scroll-reveal">
                    <h2>Contract Manufacturing</h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p>
                        Scalable, globally compliant manufacturing from gram-scale to multi-tonne
                        commercial batches
                    </p>
                </div>


                {/* Top Stats */}

                <div className="cdmo-section4-stats" data-stagger="true">

                    {[
                        { icon: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69a962de80e1ff0fb98d122c/33f700dbc_Container.png", value: "10", label: "API Manufacturing Sites" },
                        { icon: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69a962de80e1ff0fb98d122c/3257d7620_Container1.png", value: "5", label: "FDF / AH Sites" },
                        { icon: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69a962de80e1ff0fb98d122c/9ffe424b6_Container2.png", value: "1 kg–1T", label: "Batch Scale Flexibility" },
                        { icon: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69a962de80e1ff0fb98d122c/561bcb5bf_Container3.png", value: ">85%", label: "Backward Integration" }
                    ].map((item) => (

                        <div key={item.label} className="cdmo-section4-stat-card">

                            <img src={item.icon} alt={item.label} />

                            <div className="cdmo-section4-value">
                                <AnimatedCounter value={item.value} />
                            </div>

                            <div className="cdmo-section4-label">{item.label}</div>

                        </div>

                    ))}

                </div>


                {/* Middle Section */}

                <div className="cdmo-section4-mid">

                    {/* Image */}

                    <div className="cdmo-section4-image sr-left">

                        <img
                            src={cdmoContractManufacturingLeftImg}
                            alt="World-Class Manufacturing"
                        />

                        <div className="cdmo-section4-overlay"></div>

                        <div className="cdmo-section4-image-text">

                            <h3>World-Class Manufacturing</h3>

                            <p>
                                15 integrated sites with multi-agency approvals and full eGMP compliance
                            </p>

                            {/* <div className="cdmo-section4-tags">
                                {["USFDA", "EU GMP", "WHO GMP"].map((tag) => (
                                    <span key={tag}>{tag}</span>
                                ))}
                            </div> */}

                        </div>

                    </div>


                    {/* Capability Cards */}

                    <div className="cdmo-section4-caps" data-stagger="true">

                        {[
                            {
                                icon: apiCommercialIcon,
                                title: "API Commercial Manufacturing",
                                points: [
                                    "Small molecule NCEs & generics",
                                    "Dedicated 7 suites to handle OEB 4/5 products",
                                    "Stereoselective synthesis",
                                    "Complex heterocyclic chemistry"
                                ]
                            },
                            {
                                icon: fdfIcon,
                                title: "FDF Manufacturing",
                                points: [
                                    "Solid oral dose (tablets, capsules)",
                                    "Oral Liquid Dosage Form",
                                    "Sterile injectables",
                                    "Semi-solids & topicals",
                                    "Controlled release formats"
                                ]
                            },
                            {
                                icon: animalHealthIcon,
                                title: "Animal Health Manufacturing",
                                points: [
                                    "Dedicated Vet API suites",
                                    "Companion & livestock molecules",
                                    "EU & USFDA approved vet sites",
                                    "Anthelmintics, NSAIDs, anti-parasitics"
                                ]
                            },
                            {
                                icon: qualitySupplyIcon,
                                title: "Quality & Supply Chain",
                                points: [
                                    "100% USFDA approved network",
                                    "Zero Liquid Discharge facilities",
                                    "Cold chain & controlled substance handling",
                                    "ICH Q10 compliant QMS"
                                ]
                            }
                        ].map((cap) => (

                            <div key={cap.title} className="cdmo-section4-cap-card">

                                <img src={cap.icon} alt={cap.title} className="cdmo-section4-cap-icon" />

                                <h4>{cap.title}</h4>

                                <ul>
                                    {cap.points.map((pt) => (
                                        <li key={pt}>{pt}</li>
                                    ))}
                                </ul>

                            </div>

                        ))}

                    </div>

                </div>


                {/* Bottom Certifications */}

                <div className="cdmo-section4-certifications">

                    <div className="cdmo-section4-cert-title">
                        <img src={manufacturingApprovalsIcon} alt="Certifications" />
                        <span>Manufacturing Approvals & Certifications</span>
                    </div>

                    <div className="cdmo-section4-cert-tags">

                        {[

                            "FDA - US FOOD & DRUG ADMINISTRATION",

                            "EDQM",
                            "ANVISA",
                            "NMPA CHINA",
                            "PMDA",
                            "MFDS (KOREA – Ministry of Food and Drug Safety)",
                            "COFEPRIS",
                            "TGA",
                            "Health Canada",
                            "WHO-GMP",
                            "ISO 14001 Certified",
                            "ISO 45001 Certified"
                        ].map((tag) => (
                            <span key={tag}>{tag}</span>
                        ))}

                    </div>

                </div>

            </section>

            {/* ================= SECTION 5 Technology Platforms================= */}

            <section className="cdmo-section5">
                <div className="cdmo-section5-container">

                    {/* Header */}
                    <div className="cdmo-section5-header scroll-reveal">
                        <h2>Technology Platforms</h2>
                        <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                        <p>
                            Differentiated capabilities that solve the most challenging chemistry and
                            manufacturing problems
                        </p>
                    </div>

                    {/* Banner */}
                    <div className="cdmo-section5-banner scroll-reveal">
                        <img
                            src={TechnologyPlatformsBanner}
                            alt="Technology Platforms"
                        />

                        <div className="cdmo-section5-banner-overlay"></div>

                        <div className="cdmo-section5-banner-content">
                            <h3>8 Differentiated Technology Platforms</h3>
                            <p>
                                Proprietary capabilities spanning chemistry, analytics, and process safety
                                - enabling complex molecule programs others can't deliver
                            </p>
                        </div>
                    </div>

                    {/* Cards */}
                    <div className="cdmo-section5-grid" data-stagger="true">

                        {cards.map((card, index) => (
                            <div className="cdmo-section5-card" key={index}>

                                <div className="cdmo-section5-card-header">
                                    <div className="cdmo-section5-icon">
                                        <img src={card.icon} alt={card.title} />
                                    </div>

                                    <span>{card.title}</span>
                                </div>

                                <div className="cdmo-section5-card-body">
                                    <p>{card.desc}</p>

                                    <div className="cdmo-section5-tags">
                                        {card.tags.map((tag, i) => (
                                            <span key={i}>{tag}</span>
                                        ))}
                                    </div>

                                </div>
                            </div>
                        ))}

                    </div>

                </div>
            </section>

            {/* ================= SECTION 6 Lifecycle Support================= */}

            <section className="cdmo-section6">

                <div className="cdmo-s6-header scroll-reveal">
                    <h2>Lifecycle Support</h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p>
                        Continuous support from first synthesis to decades of commercial supply
                    </p>
                </div>

                {/* Timeline */}
                <div className="cdmo-s6-timeline">

                    <div className="cdmo-s6-line"></div>

                    <div className="cdmo-s6-stages" data-stagger="true">
                        {lifecycleTimeline.map((stage, index) => (
                            <div key={index} className="cdmo-s6-stage">

                                <img
                                    src={stage.icon}
                                    alt={stage.label}
                                    className="cdmo-s6-stage-icon"
                                />

                                <div className="cdmo-s6-stage-label">
                                    <div>{stage.label}</div>
                                    <span style={{ color: stage.subColor }}>
                                        {stage.sub}
                                    </span>
                                </div>

                                <img
                                    src={stage.arrow}
                                    alt=""
                                    className="cdmo-s6-arrow"
                                />

                            </div>
                        ))}
                    </div>

                </div>

                {/* Cards */}
                <div className="cdmo-s6-grid" data-stagger="true">

                    {lifecycleSupportCards.map((card, index) => (
                        <div key={index} className="cdmo-s6-card">

                            <div className="cdmo-s6-card-header">

                                <img src={card.icon} alt={card.label} />

                                <div>
                                    <div className="cdmo-s6-card-title">
                                        {card.label}
                                    </div>

                                    <div
                                        className="cdmo-s6-card-sub"
                                        style={{ color: card.subColor }}
                                    >
                                        {card.sub}
                                    </div>
                                </div>

                            </div>

                            <div className="cdmo-s6-tags">

                                {card.tags.map((tag, i) => (
                                    <span
                                        key={i}
                                        className={tag === "+2 more" ? "more" : ""}
                                    >
                                        {tag}
                                    </span>
                                ))}

                            </div>

                        </div>
                    ))}

                </div>

            </section>

            {/* ================= SECTION 7 Partnering Models ================= */}

            <section className="cdmo-section7">
                <div className="cdmo-s7-container">

                    <div className="cdmo-s7-header scroll-reveal">
                        <h2>Partnering Models</h2>
                        <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                        <p>
                            Flexible engagement structures designed around your molecule, timeline, and commercial goals.
                        </p>
                    </div>

                    <div className="cdmo-s7-grid" data-stagger="true">
                        {partneringModels.map((model, idx) => (
                            <div key={idx} className="cdmo-s7-card">
                                <div className="cdmo-s7-card-header">
                                    <div className="cdmo-s7-icon-wrapper">
                                        <img src={model.icon} alt={model.title} />
                                    </div>
                                    <h3 className="cdmo-s7-card-title">{model.title}</h3>
                                    <p className="cdmo-s7-card-ideal">{model.ideal}</p>
                                </div>
                                <div className="cdmo-s7-card-body">
                                    <p className="cdmo-s7-card-desc">{model.desc}</p>
                                    <ul className="cdmo-s7-card-list">
                                        {model.bullets.map((point, i) => (
                                            <li key={i}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="cdmo-s7-cta">
                        <div className="cdmo-s7-cta-left">
                            <div className="cdmo-s7-cta-icon">
                                <img src={cdmoS7CtaIcon} alt="Support Icon" />
                            </div>
                            <div className="cdmo-s7-cta-text">
                                <h3>Not sure which model fits?</h3>
                                <p>Our CDMO business development team can help evaluate your programme and recommend the most appropriate partnership structure - at no commitment.</p>
                            </div>
                        </div>
                        <div className="cdmo-s7-cta-right">
                            <button className="cdmo-s7-cta-btn">
                                Schedule a Discussion
                                <img src={cdmoLeftArrowIcon} alt="Arrow" className="cdmo-s7-btn-icon" />
                            </button>
                        </div>
                    </div>

                </div>
            </section>


        </>
    )
}

export default CDMO